/**
 * Store: Main Collection
 * -----------------------------------------------------------------------------
 * Main collection state and events.
 * - Only JSDOC custom parameters, ignore module state or object.
 *
 */
export default {
  namespaced: true,

  state: () => ({
    choices: '',
    filter: {},
    products: [],
    selectedProduct: null,
  }),

  getters: {

    /**
     * Gets user choices.
     * @returns {String}
     */
    getChoices(state) {
      return state.choices
    },

    /**
     * Gets available filters.
     * @returns {Object}
     */
    getFilters(state) {
      return state.filter
    },

    getColourNameByCode: (state) => (code) => {
      const swatch = state.products.filter(product => {
        if(product.metafields.find(metafield => metafield.value === code)){
          return product
        }
      })

      if(!swatch.length){
        return null
      }
      const swatchNameMetafield = swatch[0].metafields.find(
        metafield => metafield.key === 'colour_swatch_name',
      )
      return swatchNameMetafield?.value ?? null
    },
  },

  mutations: {

    /**
     * Updates choices state.
     * @param {String} choices - User choices.
     */
    updateChoices(state, choices) {
      state.choices = choices
    },

    /**
     * Updates filters state.
     * @param {Object} filter - Filters response from Boost.
     */
    updateFilters(state, filter) {
      state.filter = filter
    },

    /**
     * Update products array from Boost.
     * @param {Object} products - Filters response from Boost.
     */
     UPDATE_PRODUCTS(state, products) {
      state.products = products
    },

    /**
     * Updates the product object.
     * @param {Object} product - Product object.
     */
     UPDATE_SELECTED_PRODUCT(state, product) {
      state.selectedProduct = product
    },
  },

  actions: {

    /**
     * Updates the product object.
     * @param {Object} product - Product object.
     */
     updateSelectedProduct({ commit }, product) {
      commit('UPDATE_SELECTED_PRODUCT', product)
    },

    /**
     * Actions choices update.
     * @param {String} choices - User choices.
     */
    updateChoices({ commit }, choices) {
      commit('updateChoices', choices)
    },

    /**
     * Actions filters update.
     * @param {Object} filter - Filters response from Boost.
     */
    updateFilters({ commit }, filter) {
      commit('updateFilters', filter)
    },

    /**
     * Update products array from Boost.
     * @param {Object} products - Filters response from Boost.
     */
     updateProducts({ commit }, products) {
      commit('UPDATE_PRODUCTS', products)
    },
  },
}
